// Subset of ReportSaleCostAdjustmentsColumnName from ReportingService

export enum SaleCostAdjustmentsReportTableGroupingColumnId {
  AuditDateTime = 'auditDateTime',
  SaleId = 'saleId',
  PreviousCurrencyCode = 'previousCurrencyCode',
  CurrencyCode = 'currency',
  AdjustmentType = 'adjustmentType',
  AuditMonth = 'auditMonth',
  AuditWeek = 'auditWeek',
  AuditDay = 'auditDay',
}

export enum SaleCostAdjustmentsReportTableValueColumnId {
  TotalCost = 'totalCost',
  PreviousTotalCost = 'previousTotalCost',
  TotalCostChangeInCurrentCurrency = 'totalCostChangeInCurrentCurrency',
  QuantitySold = 'quantitySold',
  PreviousQuantitySold = 'previousQuantitySold',
  QuantityChange = 'quantityChange',
}

export const SALE_COST_ADJUSTMENTS_REPORT_TABLE_FORMULA_COLUMNS: SaleCostAdjustmentsReportTableValueColumnId[] =
  Object.values(SaleCostAdjustmentsReportTableValueColumnId);
